import { useSessionStore } from '@/stores/SessionStore'
import { useUserStore } from '@/stores/UserStore';
import { useCachedFetch } from '@/composables/useFetch'
import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals();

export const useApiForecastModels = () => {
  const userStore = useUserStore();
  const sessionStore = useSessionStore();

  async function getAvailableModelsByArea(bounds, settings) {
    if (!bounds) {
      console.warn('Bounds required for endpoint getAvailableModelsByArea')
      return
    }

    const { latMin, lonMin, latMax, lonMax } = bounds

    const defaultSettings = {
      units_wind: userStore.units.wind,
      units_temp: userStore.units.temp,
      units_distance: userStore.units.distance,
      units_precip: userStore.units.precip,
      min_lat: latMin,
      max_lat: latMax,
      min_lon: lonMin,
      max_lon: lonMax,
      wf_token: sessionStore.token
    }

    const params = Object.assign(defaultSettings, settings)
    const queryString = new URLSearchParams(params).toString()

    const url = `${$BASEURL}/model/getAvailableModelsByArea?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      return { error, data }
    } catch (error) {
      console.warn(error)

      return { error }
    }
  }

  async function getAvailableModelsByLatLon(lat, lon, settings) {
    if (!lat || !lon) {
      console.warn('Bounds required for endpoint getAvailableModelsByArea')
      return
    }

    const defaultSettings = {
      units_wind: userStore.units.wind,
      units_temp: userStore.units.temp,
      units_distance: userStore.units.distance,
      units_precip: userStore.units.precip,
      lat: lat,
      lon: lon,
      wf_token: sessionStore.token
    }

    const params = Object.assign(defaultSettings, settings)
    const queryString = new URLSearchParams(params).toString()

    const url = `${$BASEURL}/model/getAvailableModelsByLatLon?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      return { error, data }
    } catch (error) {
      console.warn(error)

      return { error }
    }
  }

  async function byArea(bounds, settings) {
    return await getAvailableModelsByArea(bounds, settings)
  }

  async function byLatLon(lat, lon, settings) {
    return await getAvailableModelsByLatLon(lat, lon, settings)
  }

  return {
    byArea,
    byLatLon
  }
}
